import React from 'react';
import type { BrandProfileMetrics } from '../../../api/payment/brand-profile.api';
import { BRAND_PROFILE_COPY, joinedLabel, metricTiles } from '../../../utils/brand-profile';

/** Số liệu hồ sơ hợp tác (spec 2026-10-12 §4). metrics null: dưới 3 đơn kết thúc, hiện "Chưa đủ dữ liệu". */
export const BrandProfileMetricsView: React.FC<{
  metrics: BrandProfileMetrics | null;
  joinedAt: string | null;
  ratingCount: number;
  role: 'creator' | 'orderer';
}> = ({ metrics, joinedAt, ratingCount, role }) => {
  const joined = joinedLabel(joinedAt);
  return (
    <div className="ui-card flex flex-col gap-3 p-4">
      <div className="ui-muted flex flex-wrap items-center justify-between gap-2 text-[13px]">
        <span>{ratingCount > 0 ? `${ratingCount} lượt đánh giá` : BRAND_PROFILE_COPY.noRatings}</span>
        {joined && <span>{joined}</span>}
      </div>
      {metrics ? (
        <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
          {metricTiles(metrics, role).map((t) => (
            <div key={t.key} className="rounded-lg border ui-divider p-3">
              <div className="ui-muted text-[12px]">{t.label}</div>
              <div className="ui-heading text-[18px] font-bold">{t.value}</div>
            </div>
          ))}
        </div>
      ) : (
        <div className="rounded-lg border ui-divider p-3 text-center">
          <div className="ui-heading text-[15px] font-semibold">{BRAND_PROFILE_COPY.notEnoughData}</div>
          <div className="ui-muted text-[12px]">{BRAND_PROFILE_COPY.notEnoughDataHint}</div>
        </div>
      )}
    </div>
  );
};
